module.exports = __webpack_public_path__ + "static/media/Palatino Linotype-01.f8cd107d.svg";